import React, { SVGProps } from "react";

interface IconProps {
  color?: string;
}

export const FXC = (props) => (
  <svg
    fill="none"
    height="58"
    viewBox="0 0 58 58"
    width="58"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29 58C45.0163 58 58 45.0163 58 29C58 12.9837 45.0163 0 29 0C12.9837 0 0 12.9837 0 29C0 45.0163 12.9837 58 29 58Z"
      fill="#8201FF"
    />
    <path
      clipRule="evenodd"
      d="M25.6253 20.0322V25.9143C25.6253 26.3022 25.9861 26.5893 26.3003 26.5893H35.5574C35.8716 26.5893 36.2324 26.8803 36.2324 27.2643V29.7715C36.2324 30.0856 35.9414 30.4465 35.5574 30.4465H26.3003C25.9861 30.4465 25.6253 30.8034 25.6253 31.1215V44.8143C25.6222 45.3327 25.3383 45.6107 24.9503 45.3929L22.2503 43.4643C21.9321 43.2713 21.7681 43.0769 21.7681 42.6929V31.1215C21.7681 30.8034 21.4034 30.4465 21.0931 30.4465H16.6574C16.269 30.4465 15.9824 30.0856 15.9824 29.7715V27.2643C15.9824 26.8881 16.269 26.5893 16.6574 26.5893H21.0931C21.4034 26.5893 21.7681 26.3022 21.7681 25.9143V16.175C21.7681 15.791 22.0807 15.5 22.3949 15.5H39.4146C39.7287 15.5 40.0896 15.8608 40.0896 16.175V18.6821C40.0896 18.9963 39.7986 19.3571 39.4146 19.3571H26.3003C25.9861 19.3571 25.6253 19.718 25.6253 20.0322Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
);

export const AmpTiny = ({ color, ...props }: IconProps & SVGProps<any>) => (
  <svg
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M1.66666 5.66661H3.93072C4.48973 4.04597 4.9545 2.69594 5.03454 2.45583C5.17715 2.028 5.41068 1.65056 5.76699 1.38333C6.12627 1.11386 6.5524 1 7.0003 1C7.44821 1 7.87433 1.11386 8.23362 1.38333C8.58993 1.65056 8.82345 2.028 8.96606 2.45583C9.0461 2.69594 9.51088 4.04597 10.0699 5.66661H12.3332C12.7014 5.66661 12.9998 5.96508 12.9998 6.33327C12.9998 6.70085 12.7023 6.99895 12.335 6.99992H1.66486C1.2975 6.99895 1 6.70085 1 6.33327C1 5.96508 1.29847 5.66661 1.66666 5.66661ZM6.56698 2.44998C6.47885 2.51608 6.37904 2.63863 6.29943 2.87746C6.22473 3.10156 5.83194 4.24317 5.3411 5.66661H8.6595C8.16867 4.24317 7.77587 3.10156 7.70117 2.87746C7.62156 2.63863 7.52176 2.51608 7.43363 2.44998C7.34848 2.38612 7.21906 2.33331 7.0003 2.33331C6.78155 2.33331 6.65213 2.38612 6.56698 2.44998Z"
      fill={color}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M1.66666 8.33324C1.29847 8.33324 1 8.63171 1 8.99989C1 9.36808 1.29847 9.66655 1.66666 9.66655H2.54981L1.70366 12.1153C1.58337 12.4632 1.76792 12.843 2.1159 12.9632C2.46388 13.0835 2.84352 12.8989 2.96381 12.5509L3.96043 9.66655H10.0402L11.0368 12.5509C11.1571 12.8989 11.5367 13.0835 11.8847 12.9632C12.2327 12.843 12.4172 12.4632 12.2969 12.1153L11.4508 9.66655H12.3332C12.7014 9.66655 12.9998 9.36808 12.9998 8.99989C12.9998 8.63171 12.7014 8.33324 12.3332 8.33324H1.66666ZM11.6669 12.3332L12.2969 12.1153C12.297 12.1153 12.297 12.1154 11.6669 12.3332ZM11.6669 12.3332C11.0368 12.551 11.0368 12.5509 11.0368 12.5509L11.6669 12.3332ZM2.3337 12.3332L2.96381 12.5509C2.96379 12.5509 2.96378 12.551 2.3337 12.3332ZM2.3337 12.3332C1.70363 12.1154 1.70364 12.1153 1.70366 12.1153L2.3337 12.3332Z"
      fill={color}
      fillRule="evenodd"
    />
    <path
      d="M1.70366 12.1153C1.58337 12.4632 1.76792 12.843 2.1159 12.9632C2.46388 13.0835 2.84352 12.8989 2.96381 12.5509M1.70366 12.1153C1.70364 12.1153 1.70363 12.1154 2.3337 12.3332M1.70366 12.1153L2.3337 12.3332M1.70366 12.1153L2.54981 9.66655H1.66666C1.29847 9.66655 1 9.36808 1 8.99989C1 8.63171 1.29847 8.33324 1.66666 8.33324H12.3332C12.7014 8.33324 12.9998 8.63171 12.9998 8.99989C12.9998 9.36808 12.7014 9.66655 12.3332 9.66655H11.4508L12.2969 12.1153M2.96381 12.5509L2.3337 12.3332M2.96381 12.5509C2.96379 12.5509 2.96378 12.551 2.3337 12.3332M2.96381 12.5509L3.96043 9.66655H10.0402L11.0368 12.5509M11.0368 12.5509C11.1571 12.8989 11.5367 13.0835 11.8847 12.9632C12.2327 12.843 12.4172 12.4632 12.2969 12.1153M11.0368 12.5509C11.0368 12.5509 11.0368 12.551 11.6669 12.3332M11.0368 12.5509L11.6669 12.3332M12.2969 12.1153L11.6669 12.3332M12.2969 12.1153C12.297 12.1153 12.297 12.1154 11.6669 12.3332M6.29943 2.87746C6.37904 2.63863 6.47885 2.51608 6.56698 2.44998C6.65213 2.38612 6.78155 2.33331 7.0003 2.33331C7.21906 2.33331 7.34848 2.38612 7.43363 2.44998C7.52176 2.51608 7.62156 2.63863 7.70117 2.87746C7.77587 3.10156 8.16867 4.24317 8.6595 5.66661H5.3411C5.83194 4.24317 6.22473 3.10156 6.29943 2.87746ZM3.93072 5.66661H1.66666C1.29847 5.66661 1 5.96508 1 6.33327C1 6.70085 1.2975 6.99895 1.66486 6.99992H12.335C12.7023 6.99895 12.9998 6.70085 12.9998 6.33327C12.9998 5.96508 12.7014 5.66661 12.3332 5.66661H10.0699C9.51088 4.04597 9.0461 2.69594 8.96606 2.45583C8.82345 2.028 8.58993 1.65056 8.23362 1.38333C7.87433 1.11386 7.44821 1 7.0003 1C6.5524 1 6.12627 1.11386 5.76699 1.38333C5.41068 1.65056 5.17715 2.028 5.03454 2.45583C4.9545 2.69594 4.48973 4.04597 3.93072 5.66661Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.4"
    />
  </svg>
);

export const AmpMark = ({ color = "#D9327C", ...props }) => (
  <svg
    fill="none"
    height="36"
    viewBox="0 0 36 36"
    width="36"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M16.7004 4.35C16.4361 4.54829 16.1366 4.91596 15.8978 5.63245C15.6737 6.30478 14.4953 9.72962 13.0228 14H22.9781C21.5056 9.72962 20.3272 6.30478 20.1031 5.63245C19.8643 4.91596 19.5648 4.54829 19.3004 4.35C19.045 4.15841 18.6567 4 18.0004 4C17.3442 4 16.9559 4.15841 16.7004 4.35ZM2 14H8.79158C10.4686 9.13803 11.863 5.08788 12.1031 4.36754C12.5309 3.08404 13.2315 1.95171 14.3005 1.15C15.3783 0.341593 16.6567 0 18.0004 0C19.3442 0 20.6226 0.341593 21.7004 1.15C22.7694 1.95171 23.47 3.08404 23.8978 4.36754C24.1379 5.08788 25.5323 9.13803 27.2093 14H34C35.1046 14 36 14.8954 36 16C36 17.1046 35.1046 18 34 18H28.5896H24.358H11.6429H7.41135H2C0.895431 18 0 17.1046 0 16C0 14.8954 0.895431 14 2 14ZM2 22C0.895431 22 0 22.8954 0 24C0 25.1046 0.895431 26 2 26H4.64878L3.57886 29.0968L2.51251 32.1826L2.11031 33.3463C1.74943 34.3902 2.30308 35.5294 3.34703 35.8902C4.39099 36.2511 5.52993 35.6971 5.89081 34.6531L6.29308 33.4892L7.35954 30.4032L8.8807 26H27.1202L28.6414 30.4032L29.7078 33.4892L30.1101 34.6531C30.471 35.6971 31.6099 36.2511 32.6539 35.8902C33.6978 35.5294 34.2515 34.3902 33.8906 33.3463L33.8903 33.3453L33.4884 32.1826L32.422 29.0968L31.3521 26H34C35.1046 26 36 25.1046 36 24C36 22.8954 35.1046 22 34 22H29.9706H25.7388H10.2621H6.03034H2ZM32.0005 34L33.8906 33.3463C33.8907 33.3465 33.8907 33.3466 32.0005 34ZM32.0005 34C30.1102 34.6534 30.1102 34.6533 30.1101 34.6531L32.0005 34ZM4.00045 34L5.89081 34.6531C5.89074 34.6533 5.8907 34.6534 4.00045 34ZM4.00045 34C2.1102 33.3466 2.11024 33.3465 2.11031 33.3463L4.00045 34Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export const AmpLogo = (props) => (
  <svg
    fill="none"
    height="70"
    viewBox="0 0 70 70"
    width="70"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="35"
      cy="35"
      fill="#D9327C"
      r="33.5"
      stroke="white"
      strokeWidth="3"
    />
    <path
      clipRule="evenodd"
      d="M33.7004 19.35C33.4361 19.5483 33.1366 19.916 32.8978 20.6325C32.6737 21.3048 31.4953 24.7296 30.0228 29H39.9781C38.5056 24.7296 37.3272 21.3048 37.1031 20.6325C36.8643 19.916 36.5648 19.5483 36.3004 19.35C36.045 19.1584 35.6567 19 35.0004 19C34.3442 19 33.9559 19.1584 33.7004 19.35ZM19 29H25.7916C27.4686 24.138 28.863 20.0879 29.1031 19.3675C29.5309 18.084 30.2315 16.9517 31.3005 16.15C32.3783 15.3416 33.6567 15 35.0004 15C36.3442 15 37.6226 15.3416 38.7004 16.15C39.7694 16.9517 40.47 18.084 40.8978 19.3675C41.1379 20.0879 42.5323 24.138 44.2093 29H51C52.1046 29 53 29.8954 53 31C53 32.1046 52.1046 33 51 33H45.5896H41.358H28.6429H24.4113H19C17.8954 33 17 32.1046 17 31C17 29.8954 17.8954 29 19 29ZM19 37C17.8954 37 17 37.8954 17 39C17 40.1046 17.8954 41 19 41H21.6488L20.5789 44.0968L19.5125 47.1826L19.1103 48.3463C18.7494 49.3902 19.3031 50.5294 20.347 50.8902C21.391 51.2511 22.5299 50.6971 22.8908 49.6531L23.2931 48.4892L24.3595 45.4032L25.8807 41H44.1202L45.6414 45.4032L46.7078 48.4892L47.1101 49.6531C47.471 50.6971 48.6099 51.2511 49.6539 50.8902C50.6978 50.5294 51.2515 49.3902 50.8906 48.3463L50.8903 48.3453L50.4884 47.1826L49.422 44.0968L48.3521 41H51C52.1046 41 53 40.1046 53 39C53 37.8954 52.1046 37 51 37H46.9706H42.7388H27.2621H23.0303H19ZM49.0005 49L50.8906 48.3463C50.8907 48.3465 50.8907 48.3466 49.0005 49ZM49.0005 49C47.1102 49.6534 47.1102 49.6533 47.1101 49.6531L49.0005 49ZM21.0005 49L22.8908 49.6531C22.8907 49.6533 22.8907 49.6534 21.0005 49ZM21.0005 49C19.1102 48.3466 19.1102 48.3465 19.1103 48.3463L21.0005 49Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
);

export const AmpCutout = ({ stroke = "#D9327C", ...props }) => (
  <svg
    fill="none"
    height="58"
    viewBox="0 0 58 58"
    width="58"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="29"
      cy="29"
      r="27"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
    />
    <path
      clipRule="evenodd"
      d="M27.9035 15.7953C27.6804 15.9626 27.4278 16.2728 27.2263 16.8774C27.0372 17.4447 26.0429 20.3344 24.8005 23.9375H33.2003C31.9578 20.3344 30.9636 17.4447 30.7745 16.8774C30.573 16.2728 30.3203 15.9626 30.0973 15.7953C29.8817 15.6337 29.5541 15.5 29.0004 15.5C28.4467 15.5 28.119 15.6337 27.9035 15.7953ZM15.5 23.9375H21.2304C22.6454 19.8352 23.8219 16.4179 24.0245 15.8101C24.3855 14.7272 24.9766 13.7718 25.8785 13.0953C26.788 12.4132 27.8666 12.125 29.0004 12.125C30.1342 12.125 31.2128 12.4132 32.1223 13.0953C33.0242 13.7718 33.6153 14.7272 33.9763 15.8101C34.1789 16.4179 35.3554 19.8352 36.7704 23.9375H42.5C43.432 23.9375 44.1875 24.693 44.1875 25.625C44.1875 26.557 43.432 27.3125 42.5 27.3125H37.9349H34.3646H23.6362H20.0658H15.5C14.568 27.3125 13.8125 26.557 13.8125 25.625C13.8125 24.693 14.568 23.9375 15.5 23.9375ZM15.5 30.6875C14.568 30.6875 13.8125 31.443 13.8125 32.375C13.8125 33.307 14.568 34.0625 15.5 34.0625H17.7349L16.8322 36.6755L15.9324 39.2791L15.5931 40.2609C15.2886 41.1418 15.7557 42.1029 16.6366 42.4074C17.5174 42.7119 18.4784 42.2444 18.7829 41.3636L19.1223 40.3815L20.0221 37.7777L21.3056 34.0625H36.6952L37.9786 37.7777L38.8785 40.3815L39.2179 41.3636C39.5224 42.2444 40.4834 42.7119 41.3642 42.4074C42.245 42.1029 42.7122 41.1418 42.4077 40.2609L42.4074 40.2601L42.0683 39.2791L41.1686 36.6755L40.2659 34.0625H42.5C43.432 34.0625 44.1875 33.307 44.1875 32.375C44.1875 31.443 43.432 30.6875 42.5 30.6875H39.1002H35.5296H22.4711H18.9006H15.5ZM40.8129 40.8125L42.4077 40.2609C42.4077 40.2611 42.4078 40.2612 40.8129 40.8125ZM40.8129 40.8125C39.218 41.3638 39.218 41.3637 39.2179 41.3636L40.8129 40.8125ZM17.1879 40.8125L18.7829 41.3636C18.7828 41.3637 18.7828 41.3638 17.1879 40.8125ZM17.1879 40.8125C15.593 40.2612 15.593 40.2611 15.5931 40.2609L17.1879 40.8125Z"
      fill={stroke}
      fillRule="evenodd"
    />
  </svg>
);

export const FXCToAmp = (props) => (
  <svg
    fill="none"
    height="59"
    viewBox="0 0 187 59"
    width="187"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="158"
      cy="30"
      opacity="0.3"
      r="27"
      stroke="#D9327C"
      strokeDasharray="0.1 8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
    />
    <path
      clipRule="evenodd"
      d="M156.904 16.7953C156.68 16.9626 156.428 17.2728 156.226 17.8774C156.037 18.4447 155.043 21.3344 153.8 24.9375H162.2C160.958 21.3344 159.964 18.4447 159.774 17.8774C159.573 17.2728 159.32 16.9626 159.097 16.7953C158.882 16.6337 158.554 16.5 158 16.5C157.447 16.5 157.119 16.6337 156.904 16.7953ZM144.5 24.9375H150.23C151.645 20.8352 152.822 17.4179 153.024 16.8101C153.385 15.7272 153.977 14.7718 154.879 14.0953C155.788 13.4132 156.867 13.125 158 13.125C159.134 13.125 160.213 13.4132 161.122 14.0953C162.024 14.7718 162.615 15.7272 162.976 16.8101C163.179 17.4179 164.355 20.8352 165.77 24.9375H171.5C172.432 24.9375 173.188 25.693 173.188 26.625C173.188 27.557 172.432 28.3125 171.5 28.3125H166.935H163.365H152.636H149.066H144.5C143.568 28.3125 142.812 27.557 142.812 26.625C142.812 25.693 143.568 24.9375 144.5 24.9375ZM144.5 31.6875C143.568 31.6875 142.812 32.443 142.812 33.375C142.812 34.307 143.568 35.0625 144.5 35.0625H146.735L145.832 37.6755L144.932 40.2791L144.593 41.2609C144.289 42.1418 144.756 43.1029 145.637 43.4074C146.517 43.7119 147.478 43.2444 147.783 42.3636L148.122 41.3815L149.022 38.7777L150.306 35.0625H165.695L166.979 38.7777L167.878 41.3815L168.218 42.3636C168.522 43.2444 169.483 43.7119 170.364 43.4074C171.245 43.1029 171.712 42.1418 171.408 41.2609L171.407 41.2601L171.068 40.2791L170.169 37.6755L169.266 35.0625H171.5C172.432 35.0625 173.188 34.307 173.188 33.375C173.188 32.443 172.432 31.6875 171.5 31.6875H168.1H164.53H151.471H147.901H144.5ZM169.813 41.8125L171.408 41.2609C171.408 41.2611 171.408 41.2612 169.813 41.8125ZM169.813 41.8125C168.218 42.3638 168.218 42.3637 168.218 42.3636L169.813 41.8125ZM146.188 41.8125L147.783 42.3636C147.783 42.3637 147.783 42.3638 146.188 41.8125ZM146.188 41.8125C144.593 41.2612 144.593 41.2611 144.593 41.2609L146.188 41.8125Z"
      fill="#D9327C"
      fillRule="evenodd"
      opacity="0.3"
    />
    <path
      d="M83 29H101"
      stroke="#8201FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <path
      d="M92 20L101 29L92 38"
      stroke="#8201FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <path
      d="M29 58C45.0163 58 58 45.0163 58 29C58 12.9837 45.0163 0 29 0C12.9837 0 0 12.9837 0 29C0 45.0163 12.9837 58 29 58Z"
      fill="#8201FF"
    />
    <path
      clipRule="evenodd"
      d="M25.6253 20.0322V25.9143C25.6253 26.3022 25.9861 26.5893 26.3003 26.5893H35.5574C35.8716 26.5893 36.2324 26.8803 36.2324 27.2643V29.7715C36.2324 30.0856 35.9414 30.4465 35.5574 30.4465H26.3003C25.9861 30.4465 25.6253 30.8034 25.6253 31.1215V44.8143C25.6222 45.3327 25.3383 45.6107 24.9503 45.3929L22.2503 43.4643C21.9321 43.2713 21.7681 43.0769 21.7681 42.6929V31.1215C21.7681 30.8034 21.4034 30.4465 21.0931 30.4465H16.6574C16.269 30.4465 15.9824 30.0856 15.9824 29.7715V27.2643C15.9824 26.8881 16.269 26.5893 16.6574 26.5893H21.0931C21.4034 26.5893 21.7681 26.3022 21.7681 25.9143V16.175C21.7681 15.791 22.0807 15.5 22.3949 15.5H39.4146C39.7287 15.5 40.0896 15.8608 40.0896 16.175V18.6821C40.0896 18.9963 39.7986 19.3571 39.4146 19.3571H26.3003C25.9861 19.3571 25.6253 19.718 25.6253 20.0322Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
);

export const IconMove = () => (
  <svg
    fill="none"
    height="25"
    viewBox="0 0 25 25"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2148 24.5273C18.8594 24.5273 24.3438 19.043 24.3438 12.4102C24.3438 5.77734 18.8477 0.292969 12.2031 0.292969C5.57031 0.292969 0.0976562 5.77734 0.0976562 12.4102C0.0976562 19.043 5.58203 24.5273 12.2148 24.5273ZM5.26562 14.0859C5.26562 11.0273 7.46875 9.12891 10.4688 9.12891H14.2539L15.6133 9.1875L14.6641 8.44922L13.3633 7.21875C13.1758 7.05469 13.0586 6.79688 13.0586 6.52734C13.0586 5.97656 13.5039 5.53125 14.043 5.53125C14.3242 5.53125 14.5352 5.625 14.7227 5.83594L18.1328 9.28125C18.3555 9.50391 18.4844 9.77344 18.4844 10.0781C18.4844 10.3828 18.3555 10.6523 18.1328 10.8633L14.7109 14.3555C14.5234 14.543 14.3008 14.6367 14.0195 14.6367C13.4922 14.6367 13.0469 14.1914 13.0469 13.6406C13.0469 13.3945 13.1523 13.125 13.3516 12.9492L14.875 11.543L15.6133 11.0039L14.2539 11.0625H10.4688C8.67578 11.0625 7.32812 12.1172 7.32812 14.0039C7.32812 15.9023 8.62891 17.0977 10.4688 17.0977H12.2852C12.8945 17.0977 13.3516 17.4609 13.3516 18.082C13.3516 18.7148 12.8945 19.1016 12.2617 19.1016H10.4688C7.46875 19.1016 5.26562 17.1562 5.26562 14.0859Z"
      fill="#D9328B"
    />
  </svg>
);

export const Bolt = ({ color = "#D9328B", ...props }) => (
  <svg
    fill="none"
    height="25"
    viewBox="0 0 25 25"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.2148 24.6797C18.8594 24.6797 24.3438 19.1953 24.3438 12.5625C24.3438 5.92969 18.8477 0.445312 12.2031 0.445312C5.57031 0.445312 0.0976562 5.92969 0.0976562 12.5625C0.0976562 19.1953 5.58203 24.6797 12.2148 24.6797ZM10.8203 19.6992C10.3047 20.3438 9.49609 19.9805 9.625 19.207L10.4219 14.5195H7.31641C6.58984 14.5195 6.35547 13.9336 6.89453 13.2539L13.0938 5.40234C13.5977 4.76953 14.4062 5.12109 14.2891 5.89453L13.4805 10.5703H16.5859C17.3242 10.5703 17.5469 11.168 17.0078 11.8477L10.8203 19.6992Z"
      fill={color}
    />
  </svg>
);

export const UpArrow = ({ fill = "#BA35D1", ...props }) => (
  <svg
    fill="none"
    height="34"
    viewBox="0 0 28 34"
    width="28"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.19141 33.9199C8.25781 33.9199 11.2695 33.041 13.2266 31.2832C15.1836 29.5254 16.1621 26.6016 16.1621 22.5117V10.3301L16.0215 5.56641L19.5195 9.41602L25.2852 15.1816C25.4258 15.3223 25.5957 15.4277 25.7949 15.498C25.9941 15.5684 26.1934 15.6035 26.3926 15.6035C26.8379 15.6035 27.2012 15.457 27.4824 15.1641C27.7754 14.8711 27.9219 14.5078 27.9219 14.0742C27.9219 13.6523 27.7578 13.2715 27.4297 12.9316L15.7578 1.24219C15.5938 1.06641 15.4121 0.9375 15.2129 0.855469C15.0137 0.761719 14.8027 0.714844 14.5801 0.714844C14.3691 0.714844 14.1641 0.761719 13.9648 0.855469C13.7656 0.9375 13.584 1.06641 13.4199 1.24219L1.74805 12.9316C1.41992 13.2715 1.25586 13.6523 1.25586 14.0742C1.25586 14.5078 1.39648 14.8711 1.67773 15.1641C1.9707 15.457 2.33398 15.6035 2.76758 15.6035C2.97852 15.6035 3.18359 15.5684 3.38281 15.498C3.58203 15.4277 3.75195 15.3223 3.89258 15.1816L9.64062 9.41602L13.1738 5.54883L13.0156 10.3301L13.0332 22.3535C13.0449 24.4746 12.7344 26.1562 12.1016 27.3984C11.4688 28.6289 10.4844 29.5078 9.14844 30.0352C7.82422 30.5742 6.11914 30.8438 4.0332 30.8438C3.62305 30.8438 3.26562 30.8379 2.96094 30.8262C2.65625 30.8145 2.35156 30.8086 2.04688 30.8086C1.58984 30.8086 1.21484 30.9434 0.921875 31.2129C0.628906 31.4824 0.482422 31.8457 0.482422 32.3027C0.482422 32.6074 0.541016 32.8594 0.658203 33.0586C0.787109 33.2578 0.951172 33.416 1.15039 33.5332C1.34961 33.6621 1.56641 33.75 1.80078 33.7969C2.07031 33.8555 2.41016 33.8906 2.82031 33.9023C3.23047 33.9141 3.6875 33.9199 4.19141 33.9199Z"
      fill={fill}
    />
  </svg>
);

export const CircleClose = ({ fill = "#A13AEE", ...props }) => (
  <svg
    fill="none"
    height="25"
    viewBox="0 0 25 25"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.2148 24.668C18.8594 24.668 24.3438 19.1836 24.3438 12.5508C24.3438 5.90625 18.8477 0.421875 12.2031 0.421875C5.57031 0.421875 0.0976562 5.90625 0.0976562 12.5508C0.0976562 19.1836 5.58203 24.668 12.2148 24.668ZM8.14844 17.7305C7.52734 17.7305 7.03516 17.2266 7.03516 16.6055C7.03516 16.3008 7.15234 16.0312 7.36328 15.832L10.6328 12.5508L7.36328 9.28125C7.15234 9.08203 7.03516 8.80078 7.03516 8.50781C7.03516 7.875 7.52734 7.39453 8.14844 7.39453C8.47656 7.39453 8.73438 7.51172 8.93359 7.72266L12.2031 10.9805L15.4961 7.71094C15.7305 7.47656 15.9766 7.38281 16.2812 7.38281C16.9141 7.38281 17.4062 7.875 17.4062 8.49609C17.4062 8.80078 17.3008 9.04688 17.0781 9.26953L13.8086 12.5508L17.0664 15.8086C17.2773 16.0312 17.3945 16.2891 17.3945 16.6055C17.3945 17.2266 16.9023 17.7305 16.2812 17.7305C15.9531 17.7305 15.6719 17.6016 15.4727 17.4023L12.2031 14.1445L8.95703 17.4023C8.75781 17.6133 8.47656 17.7305 8.14844 17.7305Z"
      fill={fill}
      opacity="0.2"
    />
  </svg>
);

export const CautionSign = (props) => (
  <svg
    fill="none"
    height="40"
    viewBox="0 0 44 40"
    width="44"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 4.10278L2.51305 32.0341C2.17876 32.6355 2.00189 33.3173 2.00002 34.0118C1.99814 34.7063 2.17134 35.3892 2.50238 35.9925C2.83342 36.5959 3.31076 37.0986 3.88692 37.4508C4.46307 37.803 5.11795 37.9924 5.7864 38H38.2136C38.882 37.9924 39.5369 37.803 40.1131 37.4508C40.6892 37.0986 41.1666 36.5959 41.4976 35.9925C41.8287 35.3892 42.0019 34.7063 42 34.0118C41.9981 33.3173 41.8212 32.6355 41.4869 32.0341L26 4.10278C25.6587 3.51833 25.0734 2.93814 24.5 2.60278C23.9266 2.26743 22.658 2 22 2C21.342 2 20.0734 2.26743 19.5 2.60278C18.9266 2.93814 18.3413 3.51833 18 4.10278Z"
      fill="#FFB701"
      stroke="#FFB701"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <path
      d="M22 14.1362V23.0908"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <path
      d="M22 30.0457H22.0199"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
  </svg>
);

export const BadNetwork = ({ color = "#8201FF", ...props }) => (
  <svg
    fill="none"
    height="70"
    viewBox="0 0 70 70"
    width="70"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.585787 0.585786C-0.195261 1.36683 -0.195263 2.63316 0.585786 3.41421L65.6396 68.468C66.4207 69.2491 67.687 69.2491 68.468 68.468C69.2491 67.687 69.2491 66.4207 68.468 65.6396L3.41421 0.585786C2.63317 -0.195262 1.36684 -0.195262 0.585787 0.585786Z"
      fill={color}
    />
    <path
      clipRule="evenodd"
      d="M2.17157 34.0001C2.17157 27.3761 4.1842 21.2222 7.63129 16.1166L10.5205 19.0058C8.10233 22.8122 6.5777 27.2421 6.2419 32.0001H20.2529C20.3147 31.0006 20.4076 30.0056 20.5312 29.0165L27.5148 36.0001H24.2612C24.8784 45.1481 28.3455 53.8736 34.1716 60.9489C37.0329 57.4741 39.3252 53.6012 40.9904 49.4757L44.0407 52.526C42.6117 55.7359 40.8281 58.7918 38.7141 61.6335C42.5084 61.0145 46.0465 59.6329 49.1659 57.6511L52.0551 60.5404C46.9494 63.9875 40.7955 66.0001 34.1716 66.0001C16.4985 66.0001 2.17157 51.6732 2.17157 34.0001ZM6.2419 36.0001H20.2529C20.8272 45.2924 24.0964 54.1963 29.629 61.6335C16.9682 59.568 7.16016 49.0113 6.2419 36.0001Z"
      fill={color}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M29.629 6.36673C27.4629 9.27858 25.6437 12.4153 24.1973 15.7121L27.2547 18.7695C28.9275 14.5523 31.2537 10.5948 34.1716 7.05133C39.9976 14.1266 43.4648 22.8522 44.0819 32.0001H40.4854L47.773 39.2877C47.9162 38.1985 48.0222 37.102 48.0903 36.0001H62.1012C61.7593 40.8455 60.1845 45.3505 57.6886 49.2033L60.573 52.0877C64.1048 46.9423 66.1716 40.7126 66.1716 34.0001C66.1716 16.327 51.8447 2.00012 34.1716 2.00012C27.4591 2.00012 21.2294 4.06687 16.084 7.59873L18.9684 10.4831C22.1383 8.42959 25.7498 6.99958 29.629 6.36673ZM48.0903 32.0001C47.5159 22.7079 44.2468 13.804 38.7141 6.36673C51.375 8.43221 61.183 18.989 62.1012 32.0001H48.0903Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export const MagnifyingGlass = ({ color = "#000", ...props }) => (
  <svg
    fill="none"
    height="28"
    viewBox="0 0 27 28"
    width="27"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.5293 22.2773C13.7031 22.2773 15.7402 21.6211 17.4355 20.5L23.4238 26.502C23.8203 26.8848 24.3262 27.0762 24.873 27.0762C26.0078 27.0762 26.8418 26.1875 26.8418 25.0664C26.8418 24.5469 26.6641 24.041 26.2812 23.6582L20.334 17.6836C21.5645 15.9473 22.2891 13.8145 22.2891 11.5176C22.2891 5.59766 17.4492 0.757812 11.5293 0.757812C5.60938 0.757812 0.769531 5.59766 0.769531 11.5176C0.769531 17.4375 5.60938 22.2773 11.5293 22.2773ZM11.5293 19.4062C7.19531 19.4062 3.64062 15.8516 3.64062 11.5176C3.64062 7.19727 7.19531 3.62891 11.5293 3.62891C15.8633 3.62891 19.418 7.19727 19.418 11.5176C19.418 15.8516 15.8633 19.4062 11.5293 19.4062Z"
      fill={color}
    />
  </svg>
);

export const Squares = ({ color = "#000", ...props }) => (
  <svg
    fill="none"
    height="46"
    viewBox="0 0 46 46"
    width="46"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.3333 2H2V18.3333H18.3333V2Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
    />
    <path
      d="M43.9994 2H27.666V18.3333H43.9994V2Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
    />
    <path
      d="M43.9994 27.6667H27.666V44.0001H43.9994V27.6667Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
    />
    <path
      d="M18.3333 27.6667H2V44.0001H18.3333V27.6667Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
    />
  </svg>
);
